{
    "Accessibility menu": "Toegankelijkheidsmenu",
    "Close": "Sluiten",
    "Content adjustments": "Inhoudsaanpassingen",
    "Navigation adjustments": "Navigatieaanpassingen",
    "Text Align": "Text Align",
    "Align Left": "Links uitlijnen",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "Lettergrootte aanpassen",
    "Highlight Title": "Titel markeren",
    "Highlight Links": "Links markeren",
    "Readable Font": "Leesbaar lettertype",
    "Colour adjustments": "Kleuraanpassingen",
    "Dark Contrast": "Donker contrast",
    "Light Contrast": "Licht contrast",
    "High Contrast": "Hoog contrast",
    "High Saturation": "Hoge verzadiging",
    "Low Saturation": "Lage verzadiging",
    "Monochrome": "Monochroom",
    "Tools": "Hulpmiddelen",
    "Reading Guide": "Leesgids",
    "Big Cursor": "Grote cursor",
    "Increase Font Size": "Lettergrootte vergroten",
    "Decrease Font Size": "Lettergrootte verkleinen",
    "Letter Spacing": "Letterafstand",
    "Line Height": "Regelhoogte",
    "Font Weight": "Lettergewicht",
    "Dyslexia Font": "Dyslexie lettertype",
    "Language": "Taal",
    "Accessibility widget": "Toegankelijkheidsmenu openen",
    "Accessibility Profiles": "Toegankelijkheidsprofielen",
    "Cognitive Disability": "Cognitieve beperking",
    "Seizure Safe": "Epilepsie veilig",
    "Accessibility statement": "Toegankelijkheidsverklaring",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "Stop animaties",
    "Reset all settings": "Instellingen resetten",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
